import { ValidationController } from "aurelia-validation";
import { SystemUserInfoDTO } from "api/swagger/ApiClient";
import { UserContact } from "../business-types";

export interface DeviationTeamRegionDirectorModel {
  data: DeviationTeamRegionDirectorDataModel;
  hasChanged: boolean;
  cancelChanges(): void;
  rebindData(dto: DeviationTeamRegionDirectorDataModel): void;
  validationController: ValidationController;
}

export interface DeviationTeamRegionDirectorDataModel {
  id: number | null;
  region: string;
  director: UserContact;
  isActive: boolean;
  archivedBy: SystemUserInfoDTO | null;
  archivedOn: string | null;
}
